//函数
import _ from 'lodash';
import viewFunction from '../../modules/index/common/viewFunction'
import BpmFunction from '../../modules/index/common/BpmFunction'
import './extend/layout/index.js'
//API
import appApi from '../api/app.js';
import freeApi from '../api/free.js';
import businessApi from '../api/business.js';
import commonApi from '../api/common.js';
import comApi from '../api/com.js';
import configApi from '../api/config.js';
import dataApi from '../api/data.js';
import orgApi from '../api/org.js';
import processApi from '../api/process.js';
import jobApi from '../api/job.js'
import oaApi from '../api/oa.js'
import oasrvApi from '../api/oa.srv.js'
import maintainApi from '../api/maintain.js';
import filemanagerApi from '../api/file-manager';
import token from '../utils/token.js'
// import store from '@/common/vuex/store'
import util from '../util'
import '../formWidget'
import '../utils/multiLang'
import '../utils/messageCenter'
import '../utils/resourceLock'
//原始组件
import Pack_Button from './packages/button/index.js';

import Util from '../util.js';
import Config from '../config.js';
import GeneralForm from './extend/general-form/index.js';
import MwForm from './extend/form/index.js';
import Loading from './extend/loading/index';
import Page from './extend/page';
import SplitPanel from './extend/split-panel';
import Tree from './extend/tree';
import Pagination from './extend/pagination';
import Table from './extend/table/index';
import MwView from './extend/view/index';
import MwFormView from './extend/view/MwFormView.vue';
import ToolbarTable from './extend/toolbar-table/index';
import UploadTable from './extend/upload/uploadTable.js';
import Dialog from './extend/dialog';
import MwProcessChartEditor from './extend/process-chart-editor';
import RightMenu from './extend/right-menu';
import View from './extend/view/index.vue'
import screenfull from 'screenfull'
import mdeditor from './extend/mdeditor'
import HtmlEditor from './extend/html-editor'
import FormulaGenerator from './extend/formula-generator'

import MwNtkoEditor from './extend/ntko/ntko-editor.vue'
import MwNtkoAttachment from './extend/ntko/ntko-attachment.vue'
import ColorSelect from '@/modules/index/components/color-select'

import MwViewToolbarTable from './extend/view/toobarTable.vue'

import invokeFormAction from './utils/invokeFormAction'

import scriptLoader from './utils/scriptLoader'

import Form_attachment from './extend/form/src/components/attachment.vue';
import Form_attachment_min from './extend/form/src/components/attachment-list-min.vue';
import Form_comment from './extend/form/src/components/comment.vue';
import Form_comment_min from './extend/form/src/components/comment-min.vue';
import Form_imbedded_view from './extend/form/src/components/imbeddedView.vue';
import Form_document_editor from './extend/form/src/components/document-editor.vue';
import Form_rel_file_selection from './extend/form/src/components/rel-file-selection.vue';
import UserFiledSelection from './extend/user-filed-selection';
import mwCompleteTree from './public-dialog/tree/index.vue';


const components = [
    Form_attachment,
    Form_attachment_min,
    Form_comment,
    Form_imbedded_view,
    Form_comment_min,
    Form_document_editor,
    Form_rel_file_selection,
    MwForm,
    ColorSelect,
    MwFormView,
    Pack_Button,
    MwView,
    MwViewToolbarTable,
    ToolbarTable,
    View,
    Page,
    Loading,
    GeneralForm,
    SplitPanel,
    Tree,
    Pagination,
    Table,
    UploadTable,
    Dialog,
    MwProcessChartEditor,
    RightMenu,
    HtmlEditor,
    FormulaGenerator,
    MwNtkoEditor,
    MwNtkoAttachment,
    UserFiledSelection,
    mwCompleteTree,
    mdeditor
];
let uploading;
const install = {
    install: function(Vue) {
        components.map(component => {
            Vue.component(component.name, component);
        });
        Vue.prototype.mwRef = function(obj) {
            return eval('this.$refs.' + obj);
        };
        Vue.prototype.mwMsg = function(arg1, arg2) {
            if (!arg2) {
                arg2 = arg1;
                arg1 = 'success';
            }
            this.$message({ type: arg1, duration: 2000, message: arg2, showClose: true });
        };
        Vue.prototype.mwLoadingClose = function() {
            uploading.close();
        }
        Vue.prototype.mwUrl = function(url) {
            return $servicePath + url
        }
        Vue.prototype.mwLoading = function(options) {
            if (options == undefined) {
                options = "加载中..."
            }
            if (typeof options == 'object') {
                uploading = this.$loading(options);
                return uploading;
            }
            uploading = this.$loading({
                lock: true,
                text: options,
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255,255, 0.8)'
            });
        };
        Vue.prototype.mwConfirm = function(msg, prompt, type) {

            if (typeof type == 'object') {
                return this.$confirm(msg, prompt, type);
            } else {
                if (!prompt) {
                    prompt = $lang('提示');
                }
                if (!type) {
                    type = 'warning'
                }
                return this.$confirm(msg, prompt, {
                    closeOnClickModal: false,
                    confirmButtonText: $lang('确定'),
                    cancelButtonText: $lang('取消'),
                    type: type
                })
            }
        }
        Vue.prototype.mwUtil = Util;
        Vue.prototype.mwConfig = Config;
        let api = {
            /*invoke:comApi.invoke,
            invokeInner:comApi.invokeInner,*/
            postUrl: comApi.ajax,
            post: util.ajax,
            get: util.ajaxGet,
            app: appApi,
            free: freeApi,
            common: commonApi,
            business: businessApi,
            com: comApi,
            config: configApi,
            data: dataApi,
            org: orgApi,
            process: processApi,
            job: jobApi,
            oa: oaApi,
            oasrv: oasrvApi,
            maintain: maintainApi,
            filemanager: filemanagerApi

        }

        Vue.prototype.mwApi = api;


        if (!MW.mwApi) {
            MW.ns("MW.mwApi");
        }
        /*  MW.mwUrl=function(url) {
            return $servicePath+url
          }*/
        MW.mwApi = api;
        MW.invoke = comApi.invoke;
        MW.invokeInner = comApi.invokeInner;
        MW.ajax = comApi.ajax;
        Vue.prototype.mwLodash = _;


        if (!window.PF) {
            window.PF = {};
        }
        PF.token = token;
        PF.encode = MW.encode;
        PF.decode = MW.decode;

        PF.apply = MW.apply;
        PF.applyIf = MW.applyIf;
        PF.Object = MW.Object
        PF.isNumber = MW.isNumber


        PF.ns = MW.ns;
        if (!PF.api) {
            PF.ns("PF.api");
        }
        PF.api = api;
        PF._ = _;
        PF.invoke = comApi.invoke;
        PF.fsrv = function(url, ...args) {
            if (url.indexOf('s:') != 0) url = "s:" + url;
            return PF.invoke(url, ...args);
        }
        //同一个服务不用系统之前调用需要用到
        PF.srv = function(url, ...args) {
          if(url.indexOf("/")===-1){
            url= window.$servicePath+"/cheetah/service/"+url
          }
          return util.ajax(url, ...args);
        }
        PF.invokeInner = comApi.invokeInner;
        /*PF.createVue = function(config) {
            config.store = store;
            return new Vue(config);
        };*/
        PF.invokeAction = function(action, context) {
            PF.action[action](context);
        }

        PF.invokeFormAction = invokeFormAction


        PF.ajax = comApi.ajax;
        PF.downloadAttachment = Util.downloadAttachment;
        PF.downloadAttachment2 = Util.downloadAttachment2;
        PF.url = function(url) {
            return $servicePath + url
        }

        PF.func = {
            bpm: BpmFunction,
            view: viewFunction,
        };
        PF.screenfull = function() {
            if (!screenfull.enabled) {
                this.$message({
                    message: '你的浏览器不支持',
                    type: 'warning'
                })
                return false
            }
            screenfull.toggle()
        }

        PF.message = function(arg1, arg2) {
            let retObj;
            if(typeof(arg1)==='object'){
              retObj= Vue.prototype.$message(arg1);
            }else{
              if (!arg2) {
                  arg2 = arg1;
                  arg1 = 'success';
              }
              retObj=Vue.prototype.$message({ type: arg1, duration: 2000, message: arg2, showClose: true });
            }
            if(!arg1.noShim){
              setTimeout(function(){
                $("body>div.el-message").each(function(){
                  if($(this).find('iframe').length===0){
                    $(this).prepend($("<iframe></iframe>").css({
                      width: 'calc(100% + 20px)',
                      height: '60px',
                      margin:"-25px 0 0 -20px",
                      "z-index":-1,
                      border: '0px',
                      position: "absolute"
                    }));
                  }
                });
              },50);
            }
            return retObj;
        };
        PF.shimMsgBox=function(){
          $("body>div.el-message-box__wrapper").each(function(){
            if($(this).find('iframe').length===0){
              $(this).prepend($("<iframe></iframe>").css({
                width: '100%',
                height: '100%',
                "z-index":-1,
                border: '0px',
                position: "absolute"
              }));
            }
          });
        }
        PF.confirm = function(msg, prompt, type) {
            if (typeof type == 'object') {
                let o=Vue.prototype.$confirm(msg, prompt, type);
                PF.shimMsgBox();
                return o;
            } else {
                if (!prompt) {
                    prompt = $lang('提示');
                }
                if (!type) {
                    type = 'warning'
                }
                let o= Vue.prototype.$confirm(msg, prompt, {
                    closeOnClickModal: false,
                    confirmButtonText:$lang( '确定'),
                    cancelButtonText:$lang( '取消'),
                    type: type
                })
                PF.shimMsgBox();
                return o;
            }
        }
        PF.alert = function(msg, title, fn) {
            if(_.isFunction(fn)){
              let o= Vue.prototype.$alert(msg, title, {
                  confirmButtonText: '确定',
                  callback: fn
              })
              PF.shimMsgBox();
              return o;
            }else{
              let o=Vue.prototype.$alert(msg, title, fn)
              PF.shimMsgBox();
              return o;
            }

        }
        PF.loading = function(options) {
            if (options == undefined) {
                options = "加载中..."
            }
            if (typeof options == 'object') {
                uploading = Vue.prototype.$loading(options);
                return uploading;
            }
            uploading = Vue.prototype.$loading({
                lock: true,
                text: options,
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255,255, 0.8)'
            });
            setTimeout(function(){
                $("body>div.el-loading-mask").each(function(){
                if($(this).find('iframe').length===0){
                    $(this).prepend($("<iframe></iframe>").css({
                    width: '100%',
                    height: '100%',
                    "z-index":-1,
                    border: '0px',
                    position: "absolute"
                    }));
                }
                });
            },50);
            return uploading;
        };

        PF.prompt = function(msg, prompt, type) {
            let retObj;
            if (typeof type === 'object') {
              retObj= Vue.prototype.$prompt(msg, prompt, type)
            } else {
                if (!prompt) {
                    prompt = '提示';
                }
                if (!type) {
                    type = 'text'
                }
              retObj= Vue.prototype.$prompt(msg, prompt, {
                    closeOnClickModal: false,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: type
                })
            }
            PF.shimMsgBox();
            return retObj;
        };

        PF.contextMenu = function(config) {
            let Comp = Vue.extend(RightMenu);
            let comp = new Comp({
                propsData: {
                    popItems: config.items
                }
            });
            let el = $(comp.$mount().$el).appendTo(document.body);
            let event;
            comp.$on("ListItemClick", function(index, item) {
                hide();

                if (item && (item.action || item.handler)) {
                    (item.action || item.handler).call(item.scope,event);
                }
            });
            function hide() {
                comp.close();
              if(config.autoDestroy){
                setTimeout(()=>{destroy();},500);
              }
            }
            if (config.el) {
                function showMenu(e) {
                    e.preventDefault();
                    let x = e.pageX;
                    let y = e.pageY;
                    comp.show(x, y);
                }

                $(config.el).contextmenu(function(e) {
                    event=e;
                    function contains(cls, child) {
                        let f = false;
                        $(config.el).find(cls).each(function() {
                            if ($.contains(this, child)) f = true;
                        });
                        return f;
                    }
                    if (config.target && !$(e.target).is(config.target) &&
                        !(config.targetContains && contains(config.target, e.target))) return;
                    if (config.excludeTarget &&
                        ($(e.target).is(config.excludeTarget) ||
                            contains(config.excludeTarget, e.target))) return;
                    showMenu(e)
                });

            }
            $(document.body).on("mousedown.contextmenu", hide);
            $(config.el).on("mousedown.contextmenu", hide);
            function destroy() {
                $(document.body).off("mousedown.contextmenu", hide);
                $(config.el).off("mousedown.contextmenu", hide);
                comp.$destroy();
                el.remove();
            }
            return {
                destroy,
                hide,
                show(x, y) { comp.show(x, y) },
            }
        }
        PF.requireJs = function(scripts, callback) {
            scriptLoader.requireJs(scripts, callback);
        }
        PF.loadCss = function(urls) {
            scriptLoader.loadCss(urls);
        };
        PF.dialog = function(comp, config) {
            if (typeof(comp) === "string") {
                let Comp = Vue.component(comp);
                if (!Comp) {
                    return PF.message("没找到注册的组件:" + comp);
                }
                comp = Comp;
            }
            let attributeHtml = "";
            if (config.propsData) {
                Object.keys(config.propsData).forEach(key => {
                    attributeHtml += ` :${key}="${key}" `
                })
            }
            if(config.eventDatas){
              Object.keys(config.eventDatas).forEach(key => {
                attributeHtml += ` @${key}="${key}" `
              })
            }
            let buttons = config.footerButton || config.buttons || config.btns;
            if (buttons) {
                buttons.forEach(btn => {
                    let fn = btn.func || btn.handler;
                    delete btn.handler;
                    btn.func = function() {
                        let comp = dlg.$refs.comp;
                        fn.call(dlg, comp);
                    };
                });
            }
            let dlg = PF.createVue({
                template: `<mwDialog ref="d"
              title=${config.title}
              :beforeClose="beforeClose"
              size="${config.size || "full"}"
              width="${config.width || ""}"
              height="${config.height || ""}"
              :footerButton="footerButton"
              @opened="opened"
              >
              <comp ref="comp" ${attributeHtml}></comp>
            </mwDialog>`,
                data: { footerButton: buttons, ...config.propsData },
                methods: {
                    beforeClose() {
                        let me = this;
                        me.$emit("beforeclose", this.$refs.comp);
                        setTimeout(function() {
                            $(me.$el).remove();
                            me.$destroy();
                        }, 200);
                    },
                    opened() {
                        this.$emit("opened", this.$refs.comp);
                    },
                    close() {
                      this.beforeClose();
                      this.$refs.d.hide() ;
                    },
                    ...config.eventDatas
                },
                mounted: function() {

                },
                components: { comp: comp }
            });
            dlg.$mount();
            $(dlg.$el).appendTo(document.body);

            dlg.$refs.d.show();
            return dlg;
        };
        PF.showMarkdown = function(config) {
            return PF.dialog(mdeditor, config);
        }
        PF.showHelp = function(config) {
            if (!config.markdown && config.url) {
                $.get(config.url, function(res) {
                    config = { markdown: res, ...config };
                    config.url = null;
                    PF.showHelp(config);
                })
                return;
            }
            return PF.showMarkdown({
                title: config.title || "帮助",
                size: "page",
                propsData: {
                    mode: "display",
                    markdown: config.markdown
                }
            });
        }
        PF.getApplicationPath = function() {
            return window.$servicePath || "";
        }
        PF.getServicePath = function() {
            return PF.getApplicationPath() + "/service"
        }
        PF.eval = function(exp, context, scope) {
            if (typeof(exp) === 'string') {
                //用字符串写法绕过stick mode下不能使用with的限制;
                let body = `
            var v;
              try {
                context=context||{};
                with(context) {
                  v = eval(exp);
                }
              } catch(e) {}
              return v;
            `;
                let fn = new Function("exp", "context", body);
                return fn.call(scope, exp, context);
            }
        }

        PF.formulaGenerator = function(config, callback) {
            let dlg = PF.dialog("mw-formula-generator", {
                title: "表达式生成",
                width: 800,
                height: 420,
                propsData: config
            });
            dlg.$on("opened", function(comp) {
                comp.$on("ok", function(data) {
                    callback(data);
                });
            })
        }

        PF.treeSelect = function(config, callback) {
            PF.dialog("MwTree", {
                title: $lang(config.title || "请选择"),
                width: config.width || 400,
                height: config.height || 500,
                propsData: {
                    multiple: config.multiple === undefined ? false : config.multiple,
                    multipleLeaf: config.multipleLeaf === undefined ? false : config.multipleLeaf,
                    expandedFirst:true,
                    treeData: config.data,
                    checkNodes:config.checkNodeIds||[]
                },
                eventDatas:{
                  dblClick(row,parent){
                    if(_.isFunction(config.dblClick)){
                      config.dblClick(row,parent)
                      this.close();
                    }
                  }
                },
                footerButton: [ {
                    label: $lang("确定"),
                    func(tree) {
                        let nodes = tree.getSelected();
                        if (callback) callback(nodes);
                        this.close();
                    }
                },{
                  label: $lang("关闭"),
                  func(tree) {
                    this.close();
                  }
                }]
            });
        };
        PF.selectComponent=function(config,callback){
          PF.show('treeTable', {
            url: PF.url("/api/app/listApplicationTree"),size:'small_large', treeDefaultParams: {category: config.category},
            selectFirst: !!config.selectFirst, clearBtn: !!config.clearBtn, title: config.title ||'选择', changed: function (data) {
              let me = this;
              me.defaultParams = {category: config.category,applicationId:data.id,simpleResult:config.simpleResult===undefined?true:config.simpleResult};
            }, api: 'app.getAppModuleItems', singleSelect: !!config.singleSelect

          }, function (res) {
            if(callback)callback(res);
          });
        };
        PF.openCenterWindowUrl = function(address, obj, widthx, hightx, onClose, openCallBack, showModalDialog) {
            if (!widthx && !hightx) {
                var isFullScreen = true;
            } else {
                isFullScreen = false;
                var windowhight = hightx;
                var windowwidth = widthx;
                var top = 0;
                if(windowhight && windowhight > 0){
                    top = (window.screen.availHeight - windowhight)/2;
                }else{
                    windowhight = window.screen.availHeight - (window.$Env && $Env.openWindowHeight || 60);
                }
                var left = (window.screen.availWidth - windowwidth) / 2;
            }
            var features = "scrollbars=1,status=no,toolbar=no,menubar=no,location=no,resizable=yes";
            var win;
            if (window.showModalDialog && showModalDialog) {
                features = features.replace(',', ';');
                win = window.showModalDialog(address, obj, 'dialogHeight =' + hightx + 'px;dialogWidth=' + widthx + 'px;' + features);
            } else
                win = window.open(address, obj, 'Height=' + windowhight + ',Left=' + left + ',Top=' + top + ',Width=' + windowwidth + ',' + features);
            if ($.isFunction(openCallBack)) {
                openCallBack.call(win);
            }
            if (isFullScreen) {
                win.moveTo(0, 0);
                win.resizeTo(screen.availWidth, screen.availHeight);
            }
            if ($.isFunction(onClose)) { PF.onWindowClose(win, onClose) }
            return win;
        }
        PF.onWindowClose = function(win, callback) {
            if (!win) return;
            var timer;
            function ifWindowClosed() {
                try {
                    if (win.closed === true) {
                        clearInterval(timer);
                        callback(win)
                        win = null;
                    }
                } catch (e) {
                    if (timer) {
                        win = null;
                        clearInterval(timer);
                    }
                }
            }
            timer = window.setInterval(ifWindowClosed, 500);
        }
        PF.urlAppend = function(url, params) {
            if (typeof params === "object") {
                function stringify(o) {
                    if ($.isPlainObject(o) || $.isArray(o)) {
                        return JSON.stringify(o);
                    } else {
                        return o;
                    }
                }
                params = _.chain(params).mapValues(v => encodeURIComponent(stringify(v))).toPairs()
                    .map(_.partial(_.join, _, "=")).join("&").value()
            }
            return url + (url.indexOf("?") > -1 ? "&" : "?") + params;
        }
        PF.initPupload = function(config, fn, callback) {
            var maxSize = config.maxSize || 10;
            PF.requireJs(["/assets/js/Plupload/js/plupload.full.min.js"], function() {
                var cfg = {
                    runtimes: 'gears,html5,flash,silverlight,browserplus,html4',
                    browse_button: config.buttonId,
                    max_file_size: maxSize + 'mb',
                    unique_names: true,
                    url: config.action || PF.url('/api/business/uploadAttachment'),
                    multi_selection: config.multi ? true : false,
                    flash_swf_url: '/assets/js/Plupload/js/Moxie.swf',
                    silverlight_xap_url: '/assets/js/Plupload/js/Moxie.xap'
                }
                if (config.accept) {
                    cfg.filters = {
                        mime_types: [
                            { title: config.title || "自定义文件", extensions: config.accept }
                        ]
                    }
                }
                var uploader = new plupload.Uploader(cfg);
                uploader.bind('Init', function(up) {
                    if (fn && fn.init) {
                        fn.init(up, files);
                    }
                });
                uploader.bind('UploadFile', function(up, file) {
                    if (fn && fn.uploadFile) {
                        return fn.uploadFile(up, file);
                    }
                })

                uploader.bind('FilesAdded', function(up, files) {
                    if (fn && fn.filesAdded) {
                        fn.filesAdded(up, files);
                    } else {
                        uploader.setOption("multipart_params", config.params);
                        if (config.autoUpload && config.autoUpload === false) return;
                        uploader.start();
                    }
                });
                uploader.bind('UploadProgress', function(up, file) {
                    if (fn && fn.uploadProgress)
                        fn.uploadProgress(up, file);
                });
                uploader.bind('FileUploaded', function(up, file, re) {
                    if (fn && fn.fileUploaded) {
                        var resp = $.parseJSON(re.response);
                        fn.fileUploaded(up, file, resp);
                    }
                })
                uploader.bind('UploadComplete', function(up, files) {
                    if (fn && fn.handleSuccess)
                        fn.handleSuccess(up, files);
                });
                uploader.bind('Error', function(up, err) {
                  if(err.response){
                    var response=JSON.parse(err.response);
                    if(response && response.result){
                      PF.message(response.result.msg);
                    }
                  }else {
                    if (err.message.indexOf("File size error") != -1)
                        PF.message($lang('上传附件大小不能超过') + maxSize + 'MB!');
                    else if (err.message.indexOf("File extension error") != -1)
                        PF.message($lang("只能上传文件类型:") + " " + config.accept );
                    else
                        PF.message(err.code + ":" + err.message + (err.file ? ", File: " + err.file.name :  ""));}
                    up.refresh();
                });
                uploader.init();
                if (callback)
                    callback(uploader);
            });
        }
        PF.walkTree = function (items,subKey,fn) {
          if(!items)return;
          if (typeof subKey === 'function') {
            fn=subKey;
            subKey='children';
          }
          items.forEach(it => {
            fn(it);
            PF.walkTree(it[subKey],subKey,fn)
          });
        };
        PF.selectDepartment=function(config,callback){
            var defaultParams = {
                deep: true,
                isContainSelf: !config.excludeSelf,
                parentId: config.parentId,
                flags: config.flag
            }
            PF.show('tree', {
                url: PF.url("/api/org/listDepartmentTree"),
                defaultParams: defaultParams,
                checkNodes: config.checkNodes,
                search: !!config.search,
                multiple: config.multiple,
                selectFirst: !!config.selectFirst,
                clearBtn: config.showClearBtn,
                singleLeaf: config.singleLeaf
            },
            function(res) {
                if(callback){callback(res)}
            });

        }
        //vue表达式里面用到的全局变量，本地开发调试时候需要。
        Vue.prototype.moment=window.moment;

    }
}

// 导出组件
export default install



// WEBPACK FOOTER //
// ./src/common/components/index_public.js